import React from "react";
import { NavLink } from "react-router-dom";
import defaultImage from '../img/default.jpg';
import frameDefault from "../img/thumb/frame-100x60.png";
import Bg01 from "../img/thumb/bg-01.jpg";
import Bg01Dark from "../img/thumb/bg-01-dark.jpg";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(CategoryScale);

export default function Home(prop) {
    let [banner, setBanner] = React.useState(null);
    let [partner, setPartner] = React.useState(null);
    let [newsCategory, setNewsCategory] = React.useState(null);
    let [newsCategoryId, setNewsCategoryId] = React.useState(null);
    let [news, setNew] = React.useState(null);
    let [scholarship, setScholarship] = React.useState(null);
    let [announce, setAnnounce] = React.useState(null);
    let [scholarshipTab, setScholarshipTab] = React.useState(1);
    let [chartDataBelongto, setChartDataBelongto] = React.useState({
        labels: [],
        datasets: [
            {
                label: prop.lang === 'en' ? ' Total' : ' จำนวน',
                data: [],
                backgroundColor: [],
                borderWidth: 1,
            }
        ]
    });
    let [chartDataResearchDoc, setChartDataResearchDoc] = React.useState({
        labels: [],
        datasets: [
            {
                label: prop.lang === 'en' ? ' Total' : ' จำนวน',
                data: [],
                backgroundColor: [],
                borderWidth: 1,
            }
        ]
    });

    React.useEffect(() => {
        let title = 'สำนักงานคณะกรรมการการรักษาความมั่นคงปลอดภัยไซเบอร์แห่งชาติ (สกมช.) | National Cyber Security Agency (NCSA)';
        document.title = title;
        const elDesc = document.querySelector("meta[name='description']");
        elDesc.setAttribute('content', title);
        const elOgTitle = document.querySelector("meta[property='og:title']");
        elOgTitle.setAttribute('content', title);
        const elOgDesc = document.querySelector("meta[property='og:description']");
        elOgDesc.setAttribute('content', title);
        const elOgImage = document.querySelector("meta[property='og:image']");
        elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
        const elOgUrl = document.querySelector("meta[property='og:url']");
        elOgUrl.setAttribute('content', window.location.href);

        (async function() {
            try {
                const bannerListing = await getBanner();
                setBanner(bannerListing);
                const scholarshipListing = await getScholarship();
                setScholarship(scholarshipListing);
                const anounceListing = await getAnnounce();
                setAnnounce(anounceListing);
                const partnerListing = await getPartner();
                setPartner(partnerListing);
                const newsCategoryListing = await getNewsCategory();
                setNewsCategory(newsCategoryListing);
                if(newsCategoryListing !== null) {
                    setNewsCategoryId(newsCategoryListing.rows[0].id);
                    const newsListing = await getNews(newsCategoryListing.rows[0].id);
                    setNew(newsListing);
                }

                const resBelongto = await getBelongto();
                const resResearchDoc = await getResearchDoctype();
                createChart(resBelongto, resResearchDoc)
            } catch (e) {
                //
            }
        })();
    }, []);

    function createChart(belongtoList, researchDocList) {

        let chartColors = [
            "#514BD3", "#FFB14C", "#43B4FF", "#26C0C7", "#56F288", "#EC5AAC", "#FAE739",
            "#3366CC", "#DC3912", "#FF9900", "#109618", "#990099", "#3B3EAC", "#0099C6",
            "#DD4477", "#66AA00", "#B82E2E", "#316395", "#994499", "#22AA99", "#AAAA11",
            "#6633CC", "#E67300", "#8B0707", "#329262", "#5574A6", "#651067"
        ];

        let belongtoLabel = [];
        let belongtoColor = [];
        let belongtoData = [];
        if(belongtoList !== null && belongtoList.length > 0) {
            let n=0;
            for(let rs of belongtoList) {
                belongtoLabel.push(prop.lang === 'en' ? rs.title_en : rs.title);
                belongtoData.push(rs.researcher ? rs.researcher.length : 0);
                belongtoColor.push(chartColors[n]);
                n++;
            }
        }

        const dataChartBelongto = {
            labels: belongtoLabel,
            datasets: [
                {
                    label: prop.lang === 'en' ? ' Total ' : ' จำนวน ',
                    data: belongtoData,
                    backgroundColor: belongtoColor,
                    borderWidth: 1,
                }
            ]
        };
        setChartDataBelongto(dataChartBelongto);

        // ------

        let researchDocLabel = [];
        let researchDocColor = [];
        let researchDocData = [];
        if(researchDocList !== null && researchDocList.length > 0) {
            let n=0;
            for(let rs of researchDocList) {
                researchDocLabel.push(prop.lang === 'en' ? rs.title_en : rs.title);
                researchDocData.push(rs.research ? rs.research.length : 0);
                researchDocColor.push(chartColors[n]);
                n++;
            }
        }

        const dataChartResearchDoc = {
            labels: researchDocLabel,
            datasets: [
                {
                    label: prop.lang === 'en' ? ' Total ' : ' จำนวน ',
                    data: researchDocData,
                    backgroundColor: researchDocColor,
                    borderWidth: 1,
                }
            ]
        };
        setChartDataResearchDoc(dataChartResearchDoc);
    }

    async function getBelongto() {
        const response = await fetch(Config.apiUrl +'/belongto/listingChart', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getResearchDoctype() {
        const response = await fetch(Config.apiUrl +'/researchDoctype/listingChart', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getBanner() {
        const response = await fetch(Config.apiUrl +'/banner/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getPartner() {
        const response = await fetch(Config.apiUrl +'/partner/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getNewsCategory() {
        const response = await fetch(Config.apiUrl +'/newsCategory/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getNews(newsCategoryId) {
        const response = await fetch(Config.apiUrl +'/news/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                categoryId: newsCategoryId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getScholarship() {
        const response = await fetch(Config.apiUrl +'/scholarship/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({

            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getAnnounce() {
        const response = await fetch(Config.apiUrl +'/announce/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({

            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            {
                banner !== null && banner.count > 0 ?
                    <>
                        <div className="section section-banner main">
                            <div className="swiper-container swiper-banner">
                                <div className="swiper-wrapper">
                                    {
                                        banner.rows.map((row, index) => {
                                            return (
                                                <div key={index} className="swiper-slide">
                                                    <img src={Config.fileUpload + 'banner/' + row?.image} alt="" />
                                                    {
                                                        row.text1 || row.text2 || row.text3 ?
                                                            <div className="container">
                                                                <div className="banner-caption">
                                                                    {
                                                                        row.text1 ? <h5>{prop.lang === 'en' ? row.text1_en:row.text1}</h5> : ''
                                                                    }
                                                                    {
                                                                        row.text2 ? <h2>{prop.lang === 'en' ? row.text2_en:row.text2}</h2> : ''
                                                                    }
                                                                    {
                                                                        row.text3 ? <p>{prop.lang === 'en' ? row.text3_en:row.text3}</p> : ''
                                                                    }
                                                                </div>
                                                            </div> : ''
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                            {
                                banner.count > 1 ? <div className="swiper-button-group banner">
                                    <div className="swiper-button swiper-button-prev"><span className="icons"></span></div>
                                    <div className="swiper-button swiper-button-next"><span className="icons"></span></div>
                                </div> : ''
                            }

                        </div>
                    </> : ''
            }

            <div className="section">
                <div className="container">
                    <h2 className="textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Scholarship News':'ข่าวทุนวิจัย'}</span>
                    </h2>

                    <div className="hgroup d-flex" data-aos="fade-in">
                        <ul className="nav nav-links nav-color-custom">
                            <li>
                                <a href="#" className={scholarshipTab === 1 ? 'active':''} data-bs-toggle="tab" onClick={e => setScholarshipTab(1)}>
                                    <span className="line-animate">{prop.lang === 'en' ? 'Scholarship':'ทุนวิจัยที่เปิดรับ'}</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" className={scholarshipTab === 2 ? 'active':''} data-bs-toggle="tab" onClick={e => setScholarshipTab(2)}>
                                    <span className="line-animate">{prop.lang === 'en' ? 'Announcement':'ประกาศจากทุนวิจัย'}</span>
                                </a>
                            </li>
                        </ul>

                        <NavLink className="link-viewall" to={prop.lang === 'en' ? '/en/' + (scholarshipTab === 1 ? 'scholarship':'announce'):(scholarshipTab === 1 ? 'scholarship':'announce')}>{prop.lang === 'en' ? 'View all':'ดูทั้งหมด'}</NavLink>
                    </div>

                    <div className={scholarshipTab === 1 ? 'row card-news-lists':'d-none'}>
                        {
                            scholarship !== null && scholarship.count > 0 ?
                                scholarship.rows.map((row, index) => {
                                    return (
                                        <div key={index} className="col-md-4 col-sm-6">
                                            <div className="card-news" data-aos="fade-in">
                                                <NavLink to={(prop.lang === 'en' ? '/en':'') + '/scholarship/detail/' + row.slug} className="card-link"></NavLink>
                                                <div className="card-photo">
                                                    <div className="photo"
                                                         style={{backgroundImage: 'url("' + (row?.image !== null ? Config.fileUpload + 'scholarship/' + row?.image : defaultImage) + '")'}}>
                                                        <img src={frameDefault} alt="" />
                                                    </div>
                                                    <label className="date">{Utils.dateDM(row.createdAt, prop.lang)}</label>
                                                </div>
                                                <div className="card-body">
                                                    <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }) : ''
                        }
                    </div>

                    <div className={scholarshipTab === 2 ? 'row card-news-lists':'d-none'}>
                        {
                            announce !== null && announce.count > 0 ?
                                announce.rows.map((row, index) => {
                                    return (
                                        <div key={index} className="col-md-4 col-sm-6">
                                            <div className="card-news" data-aos="fade-in">
                                                <NavLink to={(prop.lang === 'en' ? '/en':'') + '/announce/detail/' + row.slug} className="card-link"></NavLink>
                                                <div className="card-photo">
                                                    <div className="photo"
                                                         style={{backgroundImage: 'url("' + (row?.image !== null ? Config.fileUpload + 'announce/' + row?.image : defaultImage) + '")'}}>
                                                        <img src={frameDefault} alt="" />
                                                    </div>
                                                    <label className="date">{Utils.dateDM(row.createdAt, prop.lang)}</label>
                                                </div>
                                                <div className="card-body">
                                                    <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }) : ''
                        }
                    </div>
                </div>
            </div>

            <div className="section pt-2">
                <div className="container">
                    <h2 className="textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'News':'ข่าวอื่นๆ'}</span>
                    </h2>

                    <div className="hgroup d-flex" data-aos="fade-in">
                        <ul className="nav nav-links nav-color-custom">
                            {
                                newsCategory !== null && newsCategory.count > 0 ?
                                    newsCategory.rows.map((row, index) => {
                                        return (
                                            <li key={index}>
                                                <a href="#" className={newsCategoryId === row.id ? 'active':''} data-bs-toggle="tab" onClick={async e => {
                                                    setNewsCategoryId(row.id);
                                                    const newsListing = await getNews(row.id);
                                                    setNew(newsListing);
                                                }}>
                                                    <span className="line-animate">{prop.lang === 'en' ? row.title_en:row.title}</span>
                                                </a>
                                            </li>
                                        )
                                    }) : ''
                            }
                        </ul>

                        <NavLink className="link-viewall" to={prop.lang === 'en' ? '/en/news':'/news'}>{prop.lang === 'en' ? 'View all':'ดูทั้งหมด'}</NavLink>
                    </div>

                    <div className="row card-news-lists">
                        {
                            news !== null && news.count > 0 ?
                                news.rows.map((row, index) => {
                                    return (
                                        <div key={index} className="col-lg-3 col-sm-6">
                                            <div className="card-news bg-none" data-aos="fade-in">
                                                <NavLink to={(prop.lang === 'en' ? '/en':'') + '/news/detail/' + row.slug} className="card-link"></NavLink>
                                                <div className="card-photo">
                                                    <div className="photo"
                                                         style={{backgroundImage: 'url("' + (row?.image !== null ? Config.fileUpload + 'news/' + row?.image : defaultImage) + '")'}}>
                                                        <img src={frameDefault} alt="" />
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                    <p>{Utils.dateDMY(row.createdAt, prop.lang)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }) : <p>{prop.lang === 'en' ? 'News not found':'ไม่พบข่าวในหมวดนี้'}</p>
                        }
                    </div>
                </div>
            </div>

            <div className="section">
                <div className="background bg-01" style={{backgroundImage: 'url("'+Bg01+'")'}}></div>
                <div className="background bg-01 dark" style={{backgroundImage: 'url("'+Bg01Dark+'")'}}></div>
                <div className="container">
                    <div className="row g-3">
                        <div className="col-lg-6">
                            <div className="card-chart" data-aos="fade-in">
                                <h2 className="card-title">{prop.lang === 'en' ? 'Number of researchers' : 'จำนวนนักวิจัยในระบบ'}</h2>
                                <div className="card-body mt-4 py-3 px-5">
                                    <div style={{width:'100%', maxWidth:'300px', margin:'auto'}}>
                                    <Doughnut
                                        data={chartDataBelongto}
                                        options={{
                                            cutout: 100,
                                            plugins: {
                                                title: {
                                                    display: false
                                                },
                                                legend: {
                                                    display: false
                                                },
                                                datalabels: {
                                                    display: false,
                                                    align: 'bottom',
                                                    backgroundColor: '#ffffff',
                                                    borderRadius: 3,
                                                    font: {
                                                        size: 18,
                                                    },
                                                },
                                            }
                                        }}
                                        plugins={
                                            [ChartDataLabels, {
                                                beforeDraw: function(chart) {
                                                    var width = chart.width,
                                                        height = chart.height,
                                                        ctx = chart.ctx;
                                                    ctx.restore();
                                                    var fontSize = (height / 140).toFixed(2);
                                                    ctx.font = 'bold ' + fontSize + 'em "Noto Sans Thai"';
                                                    ctx.fillStyle = 'rgba(51, 51, 51, 1)';
                                                    ctx.textBaseline = 'top';

                                                    // Draw "Total" on the first line
                                                    var text1 = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                                                    var textX1 = Math.round((width - ctx.measureText(text1).width) / 2);
                                                    var textY1 = height / 2.3;
                                                    ctx.fillText(text1, textX1, textY1);
                                                    ctx.save();

                                                    // Draw the number on the second line
                                                    var fontSize2 = (height / 250).toFixed(2);
                                                    ctx.font = fontSize2 + 'em "Noto Sans Thai"';
                                                    ctx.fillStyle = 'rgba(153, 153, 153, 1)';
                                                    var text2 = prop.lang === 'en' ? 'Researcher':'นักวิจัย';
                                                    var textX2 = Math.round((width - ctx.measureText(text2).width) / 2);
                                                    var textY2 = height / 1.8;
                                                    ctx.fillText(text2, textX2, textY2);
                                                    ctx.save();
                                                }
                                            }]
                                        }
                                    />
                                    </div>

                                    <div className="row g-2 mt-3">
                                        {
                                            chartDataBelongto.labels.map((row, index) => {
                                                return (
                                                    <div key={index} className="col-md-6">
                                                        <div className="chart-legend">
                                                            <span className="circle" style={{backgroundColor: chartDataBelongto.datasets[0].backgroundColor[index]}}></span>
                                                            <div>
                                                                <h5>{row}</h5>
                                                                <p>
                                                                    {
                                                                        prop.lang === 'en' ? 'Total : ' + chartDataBelongto.datasets[0].data[index] : chartDataBelongto.datasets[0].data[index] + ' คน'
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="card-chart" data-aos="fade-in">
                                <h2 className="card-title">{prop.lang === 'en' ? 'Research Data':'ข้อมูลงานวิจัย'}</h2>
                                <div className="card-body mt-4 py-3 px-5">
                                    <div style={{width:'100%', maxWidth:'300px', margin:'auto'}}>
                                        <Doughnut
                                            data={chartDataResearchDoc}
                                            options={{
                                                cutout: 100,
                                                aspectRatio: 1,
                                                plugins: {
                                                    title: {
                                                        display: false
                                                    },
                                                    legend: {
                                                        display: false
                                                    },
                                                    datalabels: {
                                                        display: false,
                                                        align: 'bottom',
                                                        backgroundColor: '#ffffff',
                                                        borderRadius: 3,
                                                        font: {
                                                            size: 18,
                                                        },
                                                    },
                                                }
                                            }}
                                            plugins={
                                                [ChartDataLabels, {
                                                    beforeDraw: function(chart) {
                                                        var width = chart.width,
                                                            height = chart.height,
                                                            ctx = chart.ctx;
                                                        ctx.restore();
                                                        var fontSize = (height / 140).toFixed(2);
                                                        ctx.font = 'bold ' + fontSize + 'em "Noto Sans Thai"';
                                                        ctx.fillStyle = 'rgba(51, 51, 51, 1)';
                                                        ctx.textBaseline = 'top';

                                                        // Draw "Total" on the first line
                                                        var text1 = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                                                        var textX1 = Math.round((width - ctx.measureText(text1).width) / 2);
                                                        var textY1 = height / 2.3;
                                                        ctx.fillText(text1, textX1, textY1);
                                                        ctx.save();

                                                        // Draw the number on the second line
                                                        var fontSize2 = (height / 250).toFixed(2);
                                                        ctx.font = fontSize2 + 'em "Noto Sans Thai"';
                                                        ctx.fillStyle = 'rgba(153, 153, 153, 1)';
                                                        var text2 = prop.lang === 'en' ? 'Research':'งานวิจัย';
                                                        var textX2 = Math.round((width - ctx.measureText(text2).width) / 2);
                                                        var textY2 = height / 1.8;
                                                        ctx.fillText(text2, textX2, textY2);
                                                        ctx.save();
                                                    }
                                                }]
                                            }
                                        />
                                    </div>

                                    <div className="row g-2 mt-3">
                                        {
                                            chartDataResearchDoc.labels.map((row, index) => {
                                                return (
                                                    <div key={index} className="col-md-6">
                                                        <div className="chart-legend">
                                                            <span className="circle" style={{backgroundColor: chartDataResearchDoc.datasets[0].backgroundColor[index]}}></span>
                                                            <div>
                                                                <h5>{row}</h5>
                                                                <p>
                                                                    {
                                                                        prop.lang === 'en' ? 'Total : ' + chartDataResearchDoc.datasets[0].data[index] : chartDataResearchDoc.datasets[0].data[index] + ' งาน'
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                partner !== null && partner.count > 0 ?
                    <>
                        <div className="section" data-aos="fade-in">
                            <div className="container">
                                <h2>{prop.lang === 'en' ? 'Partner':'หน่วยงานที่เกี่ยวข้อง'}</h2>
                                <div className="swiper-overflow institution">
                                    <div className="swiper-container swiper-card">
                                        <div className="swiper-wrapper">
                                            {
                                                partner.rows.map((row, index) => {
                                                    return (
                                                        <div key={index} className="swiper-slide">
                                                            {
                                                                row.link !== null ? <NavLink to={row.link} target="_blank" title={prop.lang === 'en' ? row.title_en:row.title}><img src={Config.fileUpload + 'partner/' + row?.image} alt={prop.lang === 'en' ? row.title_en:row.title} className="logo" /></NavLink> : <img src={Config.fileUpload + 'partner/' + row?.image} alt={prop.lang === 'en' ? row.title_en:row.title} className="logo" />
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>

                                    {
                                        partner.count > 1 ? <div className="swiper-button-group">
                                            <div className="swiper-button swiper-button-prev"><span className="icons"></span></div>
                                            <div className="swiper-button swiper-button-next"><span className="icons"></span></div>
                                        </div> : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </> : ''
            }
        </>
    );
} 